// extracted by mini-css-extract-plugin
export default {"container":"TagUnit__container___g9bEa","footerButtonContainer":"TagUnit__footerButtonContainer___mf2Xc"};